import { BaseSerializer } from "./baseSerializer.ts";
import {User} from "../user.model.ts";
import {EmployeeSerializer} from "./employeeSerializer.ts";
import {PermissionSerializer} from "./permissionSerializer.ts";
import {OrganizationSerializer} from "./organizationSerializer.ts";

export class UserSerializer extends BaseSerializer {
    public deserialize(data: Record<string, any>): User {
        const user = new User();

        this._copyAttributes(user, data);

        if (data.employee) {
            const employeeSerializer = new EmployeeSerializer();
            user.employee = employeeSerializer.deserialize(data.employee);
        }

        if (data.permissions) {
            const permissionsSerializer = new PermissionSerializer();
            user.permissions = permissionsSerializer.deserialize(data.permissions);
        }

        if (data.organization) {
            const organizationSerializer = new OrganizationSerializer();
            user.organization = organizationSerializer.deserialize(data.organization);
        }

        return user;
    }
}
